import React from 'react'
import { ContentInputField } from '../../../../components/atoms/formFields/inputField/contentInputField';
import SelectOption from '../../../../components/atoms/formFields/selectOption';
import { Col, DatePicker, Row } from 'antd';
import BottomRightButton from '../../../../components/atoms/formFields/buttons/bottomRightButton';
import moment from 'moment';
import CardHeader from '../../../../components/atoms/cardHeader';

const SellerProductFilter = ({setApprovalPagination, approvalPagination}) => {
    const {RangePicker} = DatePicker;
    return (
        <div className="filter_area collapse" id="filter2">
            <div className="container">
                <CardHeader name={"Track Approval Request Filter"}/>
                <div
                    className="bg-white mb-10 px-5 py-8 radius-bottom"
                    id="ant_inputs"
                >
                    <Row gutter={[12, 12]}>
                        <Col className="gutter-row" xs={24} lg={6}>
                            <ContentInputField
                                name="Product Name"
                                value={approvalPagination?.name}
                                onChange={(e) => {
                                    setApprovalPagination({
                                        ...approvalPagination,
                                        name: e.target.value,
                                        paginationFilter: {
                                            offset: 0,
                                            limit: 10,
                                            order: "DESC",
                                        },
                                    });
                                }}
                            />
                        </Col>
                        <Col className="gutter-row" xs={24} lg={6}>
                            <SelectOption
                                showSearch
                                placeholder="Status"
                                value={approvalPagination?.status ? {
                                    label: approvalPagination?.status,
                                    value: approvalPagination?.status,
                                } : []}
                                isClearable={true}
                                options={[
                                    { label: "PENDING", value: "PENDING" },
                                    { label: "REJECTED", value: "REJECTED" },
                                    { label: "APPROVED", value: "APPROVED" },
                                ]}
                                onChange={(val) => {
                                        setApprovalPagination({
                                            ...approvalPagination,
                                            status: val?.value ? val?.value : null,
                                            paginationFilter: {
                                                offset: 0,
                                                limit: 10,
                                                order: "DESC",
                                            },
                                        });
                                }}
                            />
                        </Col>
                        <Col className="gutter-row" xs={24} lg={6}>
                            <label className="font-weight-bolder font-size-sm">
                                Select Date
                            </label>
                            <RangePicker
                                format={"DD MMM, YYYY"}
                                style={{
                                    width: "100%",
                                }}
                                disabledDate={(current) => {
                                    return moment().add(0, "days") <= current;
                                }}
                                value={[
                                    approvalPagination?.date?.from &&
                                    moment(approvalPagination?.date?.from, "DD/MM/YYYY"),
                                    approvalPagination?.date?.to &&
                                    moment(approvalPagination?.date?.to, "DD/MM/YYYY"),
                                ]}
                                onChange={(value, dateString) => {
                                    value &&
                                        setApprovalPagination({
                                            ...approvalPagination,
                                            date: {
                                                from: moment(value[0]["$d"]).format("DD/MM/YYYY"),
                                                to: moment(value[1]["$d"]).format("DD/MM/YYYY"),
                                            },
                                        });
                                }}
                            />
                        </Col>
                    </Row>
                    <div className="mt-2 text-lg-right text-center">
                        <BottomRightButton
                            onClick={() => {
                                setApprovalPagination({
                                    name: "",
                                    paginationFilter: {
                                        offset: 0,
                                        limit: 10,
                                        order: "DESC",
                                    },
                                });
                            }}
                            name="Reset"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SellerProductFilter